import { render, staticRenderFns } from "./SettingWidgetDetailsComponent.vue?vue&type=template&id=0315c534&scoped=true&"
import script from "./SettingWidgetDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingWidgetDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315c534",
  null
  
)

export default component.exports